import { SolarOrientationOption } from './technical-resource'

export const SOLAR_ORIENTATION_MAPPING: Partial<Record<MarketRegisterSolarOrientation, SolarOrientationOption>> = {
  Nord: 'North',
  NordOst: 'North-East',
  Ost: 'East',
  SuedOst: 'South-East',
  Sued: 'South',
  SuedWest: 'South-West',
  West: 'West',
  NordWest: 'North-West',
  OstWest: 'East-West',
}

export interface GenerationUnit {
  bruttoleistung: number //capacity in kW
  inbetriebnahmedatum?: string // commissioning date
  geplantesInbetriebnahmedatum?: string // commissioning date planned
  laengengrad?: number // longitude
  breitengrad?: number // latitude
}

export interface SolarGenerationUnit extends GenerationUnit {
  hauptausrichtung?: MarketRegisterSolarOrientation
}

export interface WindGenerationUnit extends GenerationUnit {
  nabenhoehe: number // turbineHubHeight
}

export const TRACKED_MODULE: MarketRegisterSolarOrientation = 'Nachgefuehrt'

type MarketRegisterSolarOrientation =
  | 'None'
  | 'Nord'
  | 'NordOst'
  | 'Ost'
  | 'SuedOst'
  | 'Sued'
  | 'SuedWest'
  | 'West'
  | 'NordWest'
  | 'Nachgefuehrt'
  | 'OstWest'
